var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total>1)?_c('paginate',{attrs:{"page-count":_vm.total,"click-handler":_vm.click,"prev-text":_vm.$t('FEED_PREV'),"next-text":_vm.$t('FEED_NEXT'),"container-class":'pagination',"page-class":'page-item'},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }